"use client";
import { useUser } from "@/context/UserContext";
import { UserType } from "@/types/inde_menu";

interface UseRoleSessionOptions<T extends UserType> {
  role: string;
  autoSwitch?: boolean;
}

export const useRoleSession = <T extends UserType>({
  role,
}: UseRoleSessionOptions<T>) => {
  const { user, isLoading } = useUser();

  const isCurrentRole = (user as any)?.role === role;
  const hasSession = !!user;

  //  functions for backwards compatibility with layouts
  const switchToThisRole = async () => true;
  const createNewSessionForRole = async () => "mock-session";
  const refreshProfile = async () => true;

  return {
    user: ((user as any) as T) || null,
    sessionId: user ? "active-session" : null,
    isLoading,
    switchToThisRole,
    createNewSessionForRole,
    refreshProfile,
    hasSession,
    isCurrentRole,
  };
};